export const SUPPORT = {
    ottry: {
        formatted: '+38 (097) 938-11-62',
        number: '+380979381162'
    },
    default : {
        formatted: '0-800-33-56-89',
        number: '0800335689'
    },
};